import { render } from "./CategoryBreakdown.vue?vue&type=template&id=f9877f96&ts=true"
import script from "./CategoryBreakdown.vue?vue&type=script&lang=ts"
export * from "./CategoryBreakdown.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\callum\\Work\\edenic-game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__